import {connect} from "react-redux";
import Logout from "./Logout";
import {logOut} from "../../actions/logOut";

export default connect(
    null,
    {logOut}
)(Logout);
